import { createApp } from 'vue';
import App from './App.vue';
import '@atum-remote/ui/styles.css';
createApp(App).mount('#app');
